export const navItems = [
  { to: '/', label: 'Census', end: true },
  { to: '/map', label: 'World Map', end: false },
  { to: '/countries', label: 'Countries', end: false },
  { to: '/networks', label: 'Networks', end: false },
  { to: '/models', label: 'Models', end: false },
  { to: '/platforms', label: 'Platforms', end: false },
  { to: '/directories', label: 'Directories', end: false },
  { to: '/discovery', label: 'Discovery', end: false },
  { to: '/methodology', label: 'Methodology', end: false },
];
